export enum LocalStorageKeysEnum {
  IS_DINE_IN_SCANNED = 'IS_DINE_IN_SCANNED',
  IS_DINING_OPTION_SELECTED_BY_USER = 'IS_DINING_OPTION_SELECTED_BY_USER',
  IS_DEFAULT_PACKING_INSTRUCTION_SET = 'IS_DEFAULT_PACKING_INSTRUCTION_SET',
  IS_ORDER_TO_TABLE = 'IS_ORDER_TO_TABLE',
  ORDER_TO_TABLE_NUMBER = 'ORDER_TO_TABLE_NUMBER',
  LS_SESSIONS = 'sessions',
}
